import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useMetaTags = () => {
  const location = useLocation();

  const metaData = {
    '/': {
      title: 'Invest Smarter Vibrant PropMart: Trusted Property Insights',
      description: 'Vibrant PropMart simplifies property investment with expert guidance, market intelligence, and curated listings for long-term real estate value.'
    },
    '/aboutus': {
      title: 'Trusted Property Solutions by Vibrant PropMart',
      description: 'Vibrant PropMart delivers smart, reliable property solutions—helping you invest with confidence through transparency, insights, and expert support.'
    },
    '/contactus': {
      title: 'Contact Vibrant PropMart for Property Assistance',
      description: 'Get expert help for all your property needs. Vibrant PropMart offers reliable assistance, from property search to final transactions and beyond.'
    },
    '/propertylist': {
      title: 'Explore Verified Property Listings | Vibrant PropMart',
      description: 'Explore trusted residential and commercial properties. Vibrant PropMart offers verified listings, expert advice, and seamless real estate assistance.'
    },
    '/properties': {
      title: 'Explore Verified Property Listings | Vibrant PropMart',
      description: 'Explore trusted residential and commercial properties. Vibrant PropMart offers verified listings, expert advice, and seamless real estate assistance.'
    },
    '/builder-partners': {
      title: 'Real Estate Builder Partners | Vibrant PropMart',
      description: 'Join Vibrant PropMart\'s trusted builder network to expand your project reach. Connect with buyers, boost sales, and grow your real estate business today.'
    },
    '/docs-required': {
      title: 'Documents Required for Property Deals | Vibrant PropMart',
      description: 'Get a complete checklist of documents needed for property buying, selling, and loans. Vibrant PropMart makes your real estate journey smooth and legal.'
    },
    '/emi-calculator': {
      title: 'Easy EMI Calculator for Home Loans | Vibrant PropMart',
      description: 'Use Vibrant PropMart\'s easy EMI calculator to estimate your monthly home loan payments instantly. Plan your budget smartly and buy your dream property with ease'
    },
    '/faqs': {
      title: 'Property Buying FAQs | Vibrant PropMart',
      description: 'Find answers to common property buying questions, from home loans to legal documents. Vibrant PropMart simplifies your real estate journey with expert help.'
    },
    '/home-loan': {
      title: 'Affordable Home Financing | Vibrant PropMart',
      description: 'Explore affordable home loan options with Vibrant PropMart. Get expert guidance, low interest rates, and easy approvals to make your dream home a reality.'
    },
    '/property-buying-steps': {
      title: 'Complete Property Buying Steps | Vibrant PropMart',
      description: 'Vibrant PropMart walks you through the property buying process step by step—helping you make informed decisions with expert insights and verified guidance.'
    },
    '/vaastu-tips': {
      title: 'Vaastu Guidelines for Positive Living | Vibrant PropMart',
      description: 'Vibrant PropMart offers simple Vaastu tips to boost positive energy, success, and wellness in your property. Make your home a haven of harmony.'
    },
    '/home-loan-facility': {
      title: 'Affordable Home Loan Facility for All Buyers',
      description: 'Vibrant PropMart offers affordable home loan facilities for first-time buyers and investors. Enjoy low rates, fast approval, and expert step-by-step help.'
    },
    '/interior-design': {
      title: 'Stylish Interior Design Services | Vibrant PropMart',
      description: 'Vibrant PropMart offers stylish and smart interior design services for modern homes. Get custom layouts, décor ideas, and expert space optimization.'
    },
    '/blog-detail': {
      title: 'Essential Tips for First-Time Home Buyers | Vibrant PropMart',
      description: 'Make your first home purchase stress-free with expert tips from Vibrant PropMart. Learn what to consider, avoid common mistakes, and buy with confidence.'
    }
  };

  useEffect(() => {
    const path = location.pathname;
    const data = metaData[path];

    if (data) {
      // Update title
      document.title = data.title;

      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = data.description;

      // Update Open Graph tags
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = data.title;

      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.content = data.description;

      // Update Twitter tags
      let twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (!twitterTitle) {
        twitterTitle = document.createElement('meta');
        twitterTitle.name = 'twitter:title';
        document.head.appendChild(twitterTitle);
      }
      twitterTitle.content = data.title;

      let twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (!twitterDescription) {
        twitterDescription = document.createElement('meta');
        twitterDescription.name = 'twitter:description';
        document.head.appendChild(twitterDescription);
      }
      twitterDescription.content = data.description;
    }
  }, [location.pathname]);
};

export default useMetaTags; 